module.exports = __webpack_public_path__ + "media/images/icon_twitter-b10a39ef65262e98edb0144407176c0d.svg";